import { Injectable } from '@angular/core';
import { G_UnitViewModel } from 'src/app/viewmodels/g-settings/G_UnitViewModel';
import { IHttpService } from '../../common/IHttpService';
import { HttpClient } from '@angular/common/http';
import { EndpointConfig } from '../../common/EndpointConfig';

@Injectable({
  providedIn: 'root'
})
export class UnitsService implements IHttpService<G_UnitViewModel>  {
  private _ep: EndpointConfig;
  constructor(private _client: HttpClient) {
    this._ep = new EndpointConfig('GSettings');
  }

  checkDublication(code) {
    return this._client.post(this._ep.getEndpointMethod('CheckUnitDublication'), { Code: code });
  }

  GetList() {
    return this._client.get(this._ep.getEndpointMethod('GetG_UnitList'));
  }

  GetById(id: any) {
    return this._client.post(this._ep.getEndpointMethod('GetG_UnitById'), { Id: id });
  }
  Post(obj: G_UnitViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_Unit'), obj);
  }

  Put(obj: G_UnitViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_Unit'), obj);
  }

  Delete(obj: G_UnitViewModel) {
    return this._client.post(this._ep.getEndpointMethod('DeleteG_Unit'), obj);
  }
}
